import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { CreditPayment } from "../state/types"

export const useCreditPaymentActions = () => {
    const saveActions = useSaveActions()

    const saveCreditPayment = (creditPayment: CreditPayment) => {
        const { save } = saveActions()
        return save(TableName.CREDIT_PAYMENTS, creditPayment) as Promise<CreditPayment>
    }

    const removeCreditPayment = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CREDIT_PAYMENTS, id)
    }

    return {
        saveCreditPayment,
        removeCreditPayment
    }
}
